import { business } from "./siteData";

// Content for the generic /bilgi/:slug informational pages (Footer's
// "Yardım" and "Yasal" link groups). Keyed by slug.
export const legalContent = {
  "teslimat-bilgileri": {
    title: "Teslimat Bilgileri",
    eyebrow: "Yardım",
    intro: "Siparişlerinizin nasıl ve ne zaman teslim edildiğine dair merak ettiğiniz her şey burada.",
    sections: [
      {
        heading: "Teslimat Bölgeleri",
        body: [
          `${business.name}, ${business.regions.join(", ")} illerine doğrudan kendi ekibiyle teslimat yapmaktadır. Bu bölgeler dışındaki illere anlaşmalı çiçekçi ortaklarımız aracılığıyla gönderim sağlanır.`,
        ],
      },
      {
        heading: "Teslimat Süreleri",
        body: [
          "Hatay merkezde saat 18:00'e kadar, Adana, Osmaniye ve Gaziantep'te saat 16:00'a kadar verilen siparişler aynı gün, sonrası verilen siparişler ise ertesi gün teslim edilir.",
          "Adana, Osmaniye ve Gaziantep için de aynı gün teslimat imkânı sunuyoruz; sabah saatlerinde verilen siparişler önceliklendirilir. Türkiye'nin diğer illerine anlaşmalı kargo firmalarımızla 1-3 iş günü içinde gönderim yapılır.",
        ],
      },
      {
        heading: "Teslimat Ücreti",
        body: [
          "Hatay merkez içi teslimatlar ücretsizdir. Diğer bölge ve şehirler arası gönderimlerde mesafeye göre değişen bir teslimat ücreti sipariş onayı sırasında bildirilir.",
        ],
      },
      {
        heading: "Teslimat Sırasında",
        body: [
          "Alıcının adreste bulunmaması durumunda kurye ekibimiz sizinle iletişime geçer; talebe göre komşu/güvenlik teslimatı veya yeniden planlama yapılabilir.",
          "Hassas ürünler olduğu için çiçek aranjmanlarının dik ve serin bir ortamda tutulmasını öneririz.",
        ],
      },
    ],
  },
  "iade-politikasi": {
    title: "İade ve Değişim Politikası",
    eyebrow: "Yardım",
    intro: "Çiçekler doğal ve çabuk bozulan ürünler olduğundan iade sürecimiz standart e-ticaret ürünlerinden farklıdır.",
    sections: [
      {
        heading: "Genel Kural",
        body: [
          "Çiçek ve bitki ürünleri, doğaları gereği Mesafeli Sözleşmeler Yönetmeliği kapsamında \"iadesi mümkün olmayan\" ürünler sınıfına girer. Bu nedenle sorunsuz teslim edilen aranjmanlar için cayma hakkı kullanılamaz.",
        ],
      },
      {
        heading: "Hasarlı veya Hatalı Ürün",
        body: [
          "Teslimat anında ürünün hasarlı, solmuş veya siparişten farklı geldiğini fark ederseniz, teslimat anında çektiğiniz fotoğrafla birlikte 24 saat içinde bizimle iletişime geçmeniz yeterlidir.",
          "İncelemenin ardından ücretsiz değişim veya tam iade sağlanır.",
        ],
      },
      {
        heading: "Değişim Süreci",
        body: [
          "Yanlış ürün/adet gönderimi, sipariş detayına uymayan aranjman veya kargo sırasında oluşan hasar gibi durumlarda ürün değişimi ücretsizdir.",
          "Değişim talebi onaylandıktan sonra, bölgenize göre aynı gün veya bir sonraki teslimat gününde yeni ürün hazırlanıp gönderilir; eski üründen kaynaklı ek bir ücret talep edilmez.",
        ],
      },
      {
        heading: "İade Talebi Nasıl Oluşturulur?",
        body: [
          `Talebinizi ${business.phone} numaralı WhatsApp/telefon hattımıza veya iletişim formumuz üzerinden iletebilirsiniz. Sipariş numaranızı belirtmeniz süreci hızlandırır.`,
        ],
      },
    ],
  },
  "kvkk-aydinlatma-metni": {
    title: "KVKK Aydınlatma Metni",
    eyebrow: "Yasal",
    intro: "6698 sayılı Kişisel Verilerin Korunması Kanunu (\"KVKK\") kapsamında veri sorumlusu sıfatıyla sizi bilgilendirmek isteriz.",
    sections: [
      {
        heading: "Veri Sorumlusu",
        body: [
          `${business.name} ("${business.shortName}") olarak, ${business.address} adresinde faaliyet göstermekteyiz ve kişisel verilerinizi veri sorumlusu sıfatıyla işlemekteyiz.`,
        ],
      },
      {
        heading: "İşlenen Veriler ve Amaçları",
        body: [
          "Ad-soyad, telefon, adres ve sipariş bilgileriniz; siparişlerinizin alınması, hazırlanması, teslimatının yapılması, faturalandırma ve müşteri hizmetleri süreçlerinin yürütülmesi amacıyla işlenir.",
          "İletişim tercihiniz doğrultusunda kampanya ve duyurular için e-posta/telefon bilgileriniz pazarlama amacıyla, açık rızanız dahilinde kullanılabilir.",
        ],
      },
      {
        heading: "Verilerin Aktarımı",
        body: [
          "Kişisel verileriniz, yalnızca teslimat süreçlerinin yürütülmesi için anlaşmalı kurye/lojistik iş ortaklarımızla ve yasal yükümlülüklerimiz gereği yetkili kamu kurumlarıyla paylaşılabilir.",
        ],
      },
      {
        heading: "Haklarınız",
        body: [
          "KVKK'nın 11. maddesi kapsamında; verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, düzeltilmesini veya silinmesini isteme haklarına sahipsiniz.",
          `Bu haklarınızı kullanmak için ${business.phone} numaralı hattımız veya iletişim sayfamız üzerinden bize ulaşabilirsiniz.`,
        ],
      },
    ],
  },
  "gizlilik-politikasi": {
    title: "Gizlilik Politikası",
    eyebrow: "Yasal",
    intro: "Web sitemizi kullanırken kişisel verilerinizin gizliliğine önem veriyoruz.",
    sections: [
      {
        heading: "Toplanan Bilgiler",
        body: [
          "Sitemizi ziyaretiniz sırasında sipariş formu, iletişim formu ve çerezler aracılığıyla ad, telefon, e-posta, teslimat adresi gibi bilgiler toplanabilir.",
        ],
      },
      {
        heading: "Bilgilerin Kullanımı",
        body: [
          "Toplanan bilgiler yalnızca sipariş süreçlerinin yürütülmesi, müşteri destek hizmetleri ve (izniniz dahilinde) kampanya bildirimleri için kullanılır. Bilgileriniz üçüncü taraflarla ticari amaçla paylaşılmaz veya satılmaz.",
        ],
      },
      {
        heading: "Veri Güvenliği",
        body: [
          "Sitemizdeki tüm veri iletimi SSL şifrelemesi ile korunur. Ödeme bilgileriniz sunucularımızda saklanmaz; güvenli ödeme altyapı sağlayıcıları üzerinden işlenir.",
        ],
      },
      {
        heading: "İletişim",
        body: [
          `Gizlilik politikamızla ilgili sorularınız için ${business.phone} numaralı hattımızdan bize ulaşabilirsiniz.`,
        ],
      },
    ],
  },
  "mesafeli-satis-sozlesmesi": {
    title: "Mesafeli Satış Sözleşmesi",
    eyebrow: "Yasal",
    intro: "6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği kapsamında düzenlenen ön bilgilendirme metnidir.",
    sections: [
      {
        heading: "Taraflar",
        body: [
          `Satıcı: ${business.name}, ${business.address}, ${business.phone} ("Satıcı").`,
          "Alıcı: Sitemiz, telefon veya WhatsApp hattı üzerinden sipariş oluşturan gerçek/tüzel kişi; sipariş sırasında bildirdiği ad-soyad, adres ve telefon bilgileriyle işbu sözleşmede taraf olarak kabul edilir (\"Alıcı\").",
        ],
      },
      {
        heading: "Konu ve Kapsam",
        body: [
          "İşbu Mesafeli Satış Sözleşmesi (\"Sözleşme\"), Alıcı'nın Satıcı'ya ait fridacicekcilik.com.tr web sitesi, telefon veya WhatsApp hattı üzerinden elektronik ortamda sipariş verdiği ürünün satışı ve teslimine ilişkin tarafların hak ve yükümlülüklerini düzenler.",
          "Alıcı, sipariş onayı vererek işbu Sözleşme'yi ve sipariş özetinde yer alan ürün, fiyat ve teslimat bilgilerini kabul etmiş sayılır.",
        ],
      },
      {
        heading: "Sözleşme Konusu Ürün ve Ödeme Bilgileri",
        body: [
          "Ürünün türü, adedi, satış bedeli (KDV dahil) ve teslimat bilgileri, Alıcı'nın sipariş sırasında onayladığı sipariş özetinde ve/veya Satıcı tarafından iletilen sipariş onayında (SMS/WhatsApp/e-posta) belirtilir; bu bilgiler işbu Sözleşme'nin ayrılmaz bir parçasıdır.",
          "Ödeme; kapıda nakit/kredi kartı, banka havalesi/EFT veya Satıcı'nın anlaşmalı olduğu ödeme kuruluşu (iyzico) üzerinden güvenli sanal pos ile yapılabilir.",
        ],
      },
      {
        heading: "Teslimat",
        body: [
          "Sipariş, Alıcı'nın bildirdiği teslimat adresine, sipariş sırasında seçilen veya Satıcı tarafından bildirilen tarih/saat aralığında teslim edilir. Güncel teslimat süre ve bölgeleri için Teslimat Bilgileri sayfamızı inceleyebilirsiniz.",
          "Alıcı'nın adreste bulunmaması halinde Satıcı, teslimatı makul bir süre içinde yeniden planlar; bu durumdan doğan gecikmelerden Satıcı sorumlu tutulamaz.",
        ],
      },
      {
        heading: "Genel Hükümler",
        body: [
          "Alıcı, sipariş vermeden önce ürünün temel nitelikleri, satış fiyatı, ödeme şekli ve teslimata ilişkin ön bilgileri okuyup bilgi sahibi olduğunu kabul eder.",
          "Satıcı, sipariş konusu ürünün mevsimsel bulunabilirlik nedeniyle temin edilememesi halinde Alıcı'yı derhal bilgilendirmekle ve talep halinde bedeli iade etmekle ya da eşdeğer bir ürün önermekle yükümlüdür.",
        ],
      },
      {
        heading: "Cayma Hakkı",
        body: [
          "Alıcı, mesafeli sözleşmelerde 14 (on dört) gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin sözleşmeden cayma hakkına sahiptir. Aşağıdaki maddede belirtilen istisnalar bu hakkın kapsamı dışındadır.",
        ],
      },
      {
        heading: "Cayma Hakkının Kullanılamayacağı Haller",
        body: [
          "Mesafeli Sözleşmeler Yönetmeliği uyarınca; çabuk bozulabilen veya son kullanma tarihi geçebilecek ürünlerin (kesme çiçek, aranjman, canlı bitki vb.) teslimine ilişkin sözleşmelerde ve Alıcı'nın istekleri doğrultusunda kişiye özel hazırlanan (özel not/mesaj eklenen) ürünlerde cayma hakkı kullanılamaz.",
          "Teslim edilen üründe kusur/hasar bulunması halinde İade ve Değişim Politikası hükümleri uygulanır.",
        ],
      },
      {
        heading: "Temerrüt Hali ve Hukuki Sonuçları",
        body: [
          "Alıcı'nın kredi kartı ile yaptığı ödemelerde temerrüde düşmesi halinde, kart sahibi banka ile arasındaki kredi kartı sözleşmesi çerçevesinde faiz ödeyeceğini ve bankaya karşı sorumlu olacağını kabul eder.",
        ],
      },
      {
        heading: "Mücbir Sebep",
        body: [
          "Doğal afet, isyan, savaş, grev, iletişim/altyapı sorunları, hava muhalefeti ve nakliye kesintisi gibi tarafların kontrolü dışında gelişen ve öngörülemeyen hallerde, Satıcı'nın teslimat yükümlülüğü mücbir sebebin ortadan kalkmasına kadar askıya alınır.",
        ],
      },
      {
        heading: "Uyuşmazlıkların Çözümü",
        body: [
          "İşbu Sözleşme'den doğan uyuşmazlıklarda, Ticaret Bakanlığı'nca her yıl belirlenen parasal sınırlar dahilinde Alıcı'nın yerleşim yerindeki Tüketici Hakem Heyeti'ne, bu sınırları aşan uyuşmazlıklarda ise Tüketici Mahkemeleri'ne başvurulabilir.",
        ],
      },
      {
        heading: "Yürürlük",
        body: [
          "Alıcı, sitemiz üzerinden sipariş verdiğinde, telefon/WhatsApp ile sözlü onay verdiğinde veya ödemeyi tamamladığında işbu Sözleşme'nin tüm hükümlerini kabul, beyan ve taahhüt eder.",
        ],
      },
    ],
  },
  "uyelik-sozlesmesi": {
    title: "Üyelik Sözleşmesi",
    eyebrow: "Yasal",
    intro: "Sitemiz üzerinden hesap oluşturan kullanıcılar ile aramızdaki üyelik ilişkisinin şartlarını düzenleyen metindir.",
    sections: [
      {
        heading: "Taraflar ve Amaç",
        body: [
          `İşbu Üyelik Sözleşmesi, ${business.name}'e ait fridacicekcilik.com.tr web sitesi ("Site") üzerinden hesap oluşturan kullanıcı ("Üye") ile ${business.shortName} ("Şirket") arasındaki üyelik ilişkisinin şartlarını düzenler.`,
        ],
      },
      {
        heading: "Üyelik Şartları",
        body: [
          "Üyelik, fiil ehliyetine sahip gerçek kişiler tarafından oluşturulabilir. Üye, kayıt sırasında verdiği ad-soyad, e-posta, telefon ve şifre bilgilerinin doğru, güncel ve kendisine ait olduğunu beyan eder.",
        ],
      },
      {
        heading: "Üyenin Hak ve Yükümlülükleri",
        body: [
          "Üye, hesabına ait kullanıcı adı ve şifrenin gizliliğinden bizzat sorumludur; hesabı üzerinden gerçekleştirilen tüm işlemler Üye tarafından yapılmış sayılır.",
          "Şifrenin üçüncü kişilerce ele geçirildiğinin fark edilmesi halinde Üye, durumu derhal Şirket'e bildirmekle yükümlüdür.",
        ],
      },
      {
        heading: "Hizmetin Kapsamı",
        body: [
          "Üyelik; sipariş geçmişinin görüntülenmesi, sipariş takibi ve hızlı sipariş oluşturma gibi kolaylıklar sağlar. Üyelik, sitemiz üzerinden ürün satın almak için zorunlu değildir; misafir olarak da sipariş verilebilir.",
        ],
      },
      {
        heading: "Fikri Mülkiyet Hakları",
        body: [
          "Site'de yer alan tüm içerik, logo, görsel ve yazılım Şirket'e aittir; Üye'nin kişisel kullanım dışında çoğaltma, dağıtma veya ticari amaçla kullanma hakkı bulunmamaktadır.",
        ],
      },
      {
        heading: "Üyeliğin Sona Ermesi",
        body: [
          "Üye, dilediği zaman hesabının silinmesini talep edebilir. Şirket, işbu Sözleşme'ye aykırı kullanım tespit etmesi halinde üyeliği askıya alma veya sonlandırma hakkını saklı tutar.",
        ],
      },
      {
        heading: "Değişiklikler ve Yürürlük",
        body: [
          "Şirket, işbu Sözleşme'yi güncelleyebilir; güncel sürüm Site'de yayımlandığı andan itibaren geçerli olur. Üye, hesap oluşturarak işbu Sözleşme'nin tüm hükümlerini kabul etmiş sayılır.",
        ],
      },
    ],
  },
  "cerez-politikasi": {
    title: "Çerez Politikası",
    eyebrow: "Yasal",
    intro: "Web sitemiz, deneyiminizi iyileştirmek amacıyla çerezler (cookies) kullanmaktadır.",
    sections: [
      {
        heading: "Çerez Nedir?",
        body: [
          "Çerezler, ziyaret ettiğiniz web siteleri tarafından tarayıcınıza yerleştirilen küçük metin dosyalarıdır ve site tercihlerinizi hatırlamamızı sağlar.",
        ],
      },
      {
        heading: "Kullandığımız Çerez Türleri",
        body: [
          "Zorunlu Çerezler: Sepet ve site içi gezinme gibi temel işlevlerin çalışması için gereklidir.",
          "Performans Çerezleri: Site kullanımını analiz ederek deneyimi iyileştirmemize yardımcı olur.",
        ],
      },
      {
        heading: "Çerez Tercihlerinizi Yönetme",
        body: [
          "Tarayıcınızın ayarlar menüsünden çerezleri her zaman silebilir veya engelleyebilirsiniz. Ancak bazı çerezlerin engellenmesi sitenin bazı bölümlerinin düzgün çalışmamasına neden olabilir.",
        ],
      },
    ],
  },
};

export function getLegalPage(slug) {
  return legalContent[slug] || null;
}
